import { useEffect } from "react";

// Shared "Enter submits the primary action" behavior for the add/edit
// modals — was previously copy-pasted identically across AddUser, AddGroup,
// AddVehicle, and AddPerson.
const useEnterKeySubmit = (onSubmit) => {
  useEffect(() => {
    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" && target.type !== "submit")
        ) {
          return;
        }
        event.preventDefault();
        onSubmit();
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [onSubmit]);
};

export default useEnterKeySubmit;
